module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/news-f9d41ba2f51fed883e5fc7c5ce1dbd20.webp";